
import { Component, Input } from "@angular/core";

@Component({
    selector: "app-clickable-data-card",
    imports: [],
    templateUrl: "./clickable-data-card.component.html",
    styleUrl: "./clickable-data-card.component.scss"
})
export class ClickableDataCardComponent {
  @Input({ required: true }) icon!: "currency" | "wallet" | "ticket";
  @Input({ required: true }) title: string = "";
  @Input({ required: true }) data: string = "";
  @Input() size: "small" | "large" = "large";
}
